import { Table, Space, Button, Typography, Popconfirm, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { EditOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import DealerMappingFilters from "./DealerMappingFilters";

const { Text } = Typography;

const DealerMappingTable = (props: any) => {
  const {
    brand,
    onEditDealerMapping,
    onDeleteDealerMapping,
    setDealerMappingQueryParams,
    dealerMappingsData,
    dealerMappingQueryParams,
    isFetching
  } = props;

  const dealer_mappings = dealerMappingsData?.third_party_dealer_mappings || [];

  const columns: ColumnsType<any> = [
    {
      title: "Dealer Name",
      dataIndex: "dealer_name",
      key: "dealer_name"
    },
    {
      title: "Dealer Code",
      dataIndex: "dealer_code",
      key: "dealer_code"
    },
    {
      title: "Branch City",
      dataIndex: "branch_city",
      key: "branch_city",
      render: (branch_city) => <Text>{branch_city ? branch_city?.name : "-"}</Text>
    },
    {
      title: "Branch State",
      dataIndex: "branch_state",
      key: "branch_state",
      render: (branch_state) => <Text>{branch_state ? branch_state?.name : "-"}</Text>
    },
    {
      title: "Assigned City Manager",
      dataIndex: "assigned_city_manager",
      key: "assigned_city_manager",
      render: (assigned_city_manager) => (
        <Text>{assigned_city_manager ? assigned_city_manager?.name : "-"}</Text>
      )
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (tag) => (
        <Tag color={tag === "active" ? "green" : "red"} key={tag}>
          {tag.toUpperCase()}
        </Tag>
      )
    },
    {
      title: "Action",
      key: "action",
      render: (_, dealer_mapping) => (
        <Space size="middle" direction="horizontal">
          <>
            <Link to={`/dealer_mappings/${dealer_mapping?.id}`}>
              <Button icon={<EyeOutlined />} title="View"></Button>
            </Link>
            <Button
              icon={<EditOutlined />}
              onClick={() => onEditDealerMapping(dealer_mapping)}
              title="Update"
            ></Button>
            <Popconfirm
              title="Are you sure you want to delete dealer mapping details"
              okText="Delete"
              placement="bottom"
              cancelText="Cancel"
              onConfirm={(event) => {
                onDeleteDealerMapping(dealer_mapping?.id);
              }}
              onCancel={(event: any) => {
                event.stopPropagation();
              }}
            >
              <Button icon={<DeleteOutlined />} title="Delete"></Button>
            </Popconfirm>
          </>
        </Space>
      )
    }
  ];

  const pagination = {
    pageSize: 20,
    current: dealerMappingQueryParams?.page,
    total: dealerMappingsData?.meta?.total_count,
    showSizeChanger: false,
    onChange: (page: number) => {
      const values: any = { page: page };
      setDealerMappingQueryParams((oldValues: any) => ({ ...oldValues, ...values }));
    }
  };

  return (
    <>
      <DealerMappingFilters
        brand={brand}
        applyFilters={(values: any) =>
          setDealerMappingQueryParams((oldValues: any) => ({ ...oldValues, ...values, page: 1 }))
        }
      />

      <Table
        rowKey="id"
        bordered
        columns={columns}
        pagination={pagination}
        dataSource={dealer_mappings}
        scroll={{ x: 400 }}
        loading={isFetching}
      />
    </>
  );
};

export default DealerMappingTable;
